import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import moment from "moment";
import { Radio, FormControlLabel, RadioGroup } from "@mui/material";

import { useQnaDetail, useCreateAnswer } from "../../api/qnaApi";
import { translator } from "../../utils/translator";
import { QuestionStatusArray, type QuestionStatus } from "../../types/qna";
import DownloadSharpIcon from "@mui/icons-material/DownloadSharp";

const QnaAnswer = () => {
  const { id } = useParams() as { id: string };
  const { data, isLoading } = useQnaDetail({ id });
  const { mutateAsync: createAnswer } = useCreateAnswer({ id });
  const question: any = useMemo(() => data?.question, [data]);
  const navigate = useNavigate();

  const [status, setStatus] = useState<QuestionStatus | "">("");
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    if (data) {
      setStatus(data.question.status);
      setAnswer(data.question.answer?.content || "");
    }
  }, [data]);

  const submit = useCallback(async () => {
    if (!status) {
      alert("처리 상태를 선택하세요.");
      return;
    }

    if (status === "answered" && !answer) {
      alert("답변을 입력하세요.");
      return;
    }

    await createAnswer({ status, content: answer });
    alert("답변이 성공적으로 등록되었습니다.");
    navigate("..");
  }, [status, answer]);

  if (isLoading) return <p>로딩 중</p>;

  return (
    <div className="narrowContent">
      <Link to={`..${window.location.search}`} className="moveButton">
        목록으로
      </Link>
      <h3 style={{ backgroundColor: "var(--primary-200)" }}>게시글</h3>
      <p>
        <b>제목:</b> {question.title}
      </p>
      <p>
        <b>의견 구분:</b> {translator[question.type]}
      </p>
      <p>
        <b>처리 상태:</b> {translator[question.status]}
      </p>
      <p>
        <b>작성자:</b> {question.user_name}
      </p>
      <p>
        <b>전화번호:</b> {question.phone}
      </p>
      <p>
        <b>이메일:</b> {question.email}
      </p>
      <p>
        <b>작성일시:</b> {moment(question.created_at).format("YYYY-MM-DD LT")}
      </p>
      <hr />
      <p>
        <b>내용</b>
      </p>
      <div style={{ whiteSpace: "pre-line" }}>{question.content}</div>
      <hr />
      <div>
        <p>
          <b>첨부파일</b>
        </p>
        {question.signed_urls?.length
          ? question.signed_urls.map(
              ({ filename, url }: { filename: string; url: string }) => (
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-button"
                >
                  <DownloadSharpIcon /> {filename}
                </a>
              )
            )
          : "없음"}
      </div>
      <h3 style={{ backgroundColor: "var(--primary-200)" }}>답변</h3>
      {question.status === "answered" ? (
        <>
          <p>
            답변일시:{" "}
            {moment(question.answer.created_at).format("YYYY-MM-DD LT")}
          </p>
          <div>{question.answer.content}</div>
        </>
      ) : (
        <>
          <RadioGroup
            row
            value={status}
            onChange={(e) => {
              setStatus(e.target.value as QuestionStatus);
            }}
          >
            {QuestionStatusArray.map((status) => (
              <FormControlLabel
                key={status}
                value={status}
                control={<Radio />}
                label={translator[status]}
              />
            ))}
          </RadioGroup>
          <textarea
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
          />
          <div className="submitButtonWrapper">
            <button type="submit" onClick={submit}>
              제출
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default QnaAnswer;
